import { format, isValid, parse } from 'date-fns'
import React from 'react'

const Availabilities = (props) => {
    const weekdays = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday']
    return (
        <div className="teacher-availabilities">
            {weekdays.map((day) => 
                <div key={day} className="teacher-availabilities__each-day">
                    {props.wholeAvail[day].length > 0 &&
                        <div className='teacher-avail__each'>
                            <div className='teacher-avail__each-day'><strong>{day}</strong></div>
                            {props.wholeAvail[day].map((times, i) => <div className="each-availability-strip" key={i}> {times.start && format(parse(times.start, 'H:mm', new Date()), 'h:mm a')} to { times.end && format(parse(times.end, 'H:mm', new Date()), 'h:mm a')}</div>)}
                        </div>
                    }
                </div>
            )}
        </div>
    )
}

export default Availabilities